import { useCssInJs } from "../../../../../hooks";
import { getSubTaskListStyle } from "./styles";
import { useTaskDetailDrawer } from "../../TaskDetail";
import cls from 'classnames';
import { Col, Row } from 'antd';
import { ReactComponent as TaskCompleteIcon } from "../../../../../assets/svg/icon-task-complete.svg";
import { ReactComponent as TaskCurrentIcon } from "../../../../../assets/svg/icon-task-current.svg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SubTaskList(props) {
  var prefix = 'sub-task-list';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getSubTaskListStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var data = props.data;
  var openTaskDetail = useTaskDetailDrawer();
  var handleOpenSubTaskDetail = function handleOpenSubTaskDetail(ev, item) {
    ev.preventDefault();
    var flowOrderId = item.flowOrderId,
      task = item.currentTaskOrder;
    openTaskDetail({
      // taskOrderId 可能为空, 所以需要 flowOrderId 兜底
      taskOrderId: task === null || task === void 0 ? void 0 : task.taskOrderId,
      flowOrderId: flowOrderId
    }).catch(function () {});
  };
  if ((data === null || data === void 0 ? void 0 : data.length) <= 0) {
    return null;
  }
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    className: cls(prefix, hashId),
    children: /*#__PURE__*/_jsx(Row, {
      gutter: 16,
      className: "rowContent",
      children: data.map(function (item, index) {
        var flowOrderName = item.flowOrderName,
          finishTime = item.finishTime,
          createTime = item.createTime;
        var task = item.currentTaskOrder;
        var isFinished = Boolean(finishTime);
        var title = flowOrderName || '-';
        var desc = finishTime || "\u5F53\u524D\u8282\u70B9\uFF1A".concat((task === null || task === void 0 ? void 0 : task.nodeName) || '-');
        var help = createTime || '-';
        return /*#__PURE__*/_jsx(Col, {
          span: 24,
          className: cls(hashId, 'colStyle'),
          onClick: function onClick(ev) {
            return handleOpenSubTaskDetail(ev, item);
          },
          children: /*#__PURE__*/_jsxs("div", {
            className: cls(hashId, 'subTaskItemWrap'),
            children: [/*#__PURE__*/_jsx("div", {
              className: cls(hashId, 'subTaskIconWrap'),
              children: isFinished ? /*#__PURE__*/_jsx(TaskCompleteIcon, {}) : /*#__PURE__*/_jsx(TaskCurrentIcon, {})
            }), /*#__PURE__*/_jsxs("div", {
              className: cls(hashId, 'subTaskContent'),
              children: [/*#__PURE__*/_jsx("p", {
                className: cls(hashId, 'subTaskTitle'),
                children: title
              }), /*#__PURE__*/_jsx("p", {
                className: cls(hashId, 'subTaskDesc'),
                children: desc
              }), /*#__PURE__*/_jsx("p", {
                className: cls(hashId, 'help'),
                children: help
              })]
            })]
          })
        }, index);
      })
    })
  }));
}